import _ from 'lodash';
import { articleStyle } from '../articleStyle';

export const SupercedenceList = ({ articles }) => {
  //map through the articles grabbing supercedence values
  //removes all undefined and null values from supercedence list
  const supercedenceList = _(articles)
    .map(article => article?.supercedence)
    .value();

  if (supercedenceList.length === 0) {
    return <>-</>;
  }

  return (
    //returns supercedence values in a new line
    <ul style={{ listStyleType: 'none', padding: 0 }}>
      {supercedenceList.map(supercedence => (
        <li
          key={`supercedence-item-${supercedence}`}
          style={{ ...articleStyle.li }}
        >
          {supercedence || '-'}
        </li>
      ))}
    </ul>
  );
};
